import { cn } from '@/lib/ui/utils';
import type { ElementType, HTMLAttributes, ReactNode } from 'react';

type CmsSectionWidth = 'default' | 'wide' | 'tight' | 'narrow' | 'faq';
type CmsSectionSpacing = 'default' | 'hero';

const widthClassMap: Record<CmsSectionWidth, string> = {
  default: 'cms-section',
  wide: 'cms-section-wide',
  tight: 'cms-section-tight',
  narrow: 'cms-section-narrow',
  faq: 'cms-section-faq',
};

const spacingClassMap: Record<CmsSectionSpacing, string> = {
  default: 'cms-block-shell',
  hero: 'cms-block-shell cms-block-shell-hero',
};

type CmsSectionShellProps<T extends ElementType> = {
  as?: T;
  width?: CmsSectionWidth;
  spacing?: CmsSectionSpacing;
  className?: string;
  innerClassName?: string;
  children: ReactNode;
} & Omit<HTMLAttributes<HTMLElement>, 'className' | 'children'>;

export function CmsSectionShell<T extends ElementType = 'section'>({
  as,
  width = 'default',
  spacing = 'default',
  className,
  innerClassName,
  children,
  ...props
}: CmsSectionShellProps<T>) {
  const Component = (as ?? 'section') as ElementType;

  return (
    <Component
      className={cn('cms-width-guard', spacingClassMap[spacing], className)}
      {...props}
    >
      <div
        className={cn('cms-width-guard', widthClassMap[width], innerClassName)}
      >
        {children}
      </div>
    </Component>
  );
}
